
import { CardActionArea } from "@mui/material";
import React from "react";

const Down = () => {
  return (
    <div style={{ paddingTop: 150 }}>
      <h2 className="text-lighting text-center mb-4">ดาวน์โหลดได้แล้ววันนี้!</h2>
      <div className="container">
        <div className="row mt-2">
          <div className="col-md-5 col-12">
            <img
              src="https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/desktop/page11/Asset036.png"
              width="100%"
            />
          </div>
          <div className="col-md-1 col-12"></div>
          <div className="col-md">
            <CardActionArea
              href="https://gpf-cdn.azureedge.net/images/statement/mygpf2565.html"
              target="_blank">
              <img
                src="https://gpfimg-cdn.azureedge.net/micrositemygpftwins/Asset21.webp"
                className="mb-5 pt-5 pb-5"
                width="100%"
              />
            </CardActionArea>
            <CardActionArea
              href="https://cfl.gpf.or.th/Files/Viewer/?fileName=5a29182e-d122-4ff0-9c71-850c449ee70e/how_to_download_my_gpf_app.pdf"
              target="_blank">
              <img
                src="https://gpfimg-cdn.azureedge.net/micrositemygpftwins/Asset22.png"
                className="mt-5"
                width="100%"
              />
            </CardActionArea>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Down;